import React, { createContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Outlet, useParams } from 'react-router-dom'
import NavBar from './NavBar'
import gql from 'graphql-tag'
import { useMutation, useQuery } from '@apollo/client'
import { Helmet } from 'react-helmet'

export const GET_KYC = gql`
  query getKyc($id: ID!) {
    getKyc(id: $id) {
      id
      token
      verified
      rejected
      completed
      errorUrl
      returnUrl
      countryCode
      documentType
      complianceType
    }
  }
`

const UPDATE_KYC = gql`
  mutation updateKyc($input: UpdateKycInput!) {
    updateKyc(input: $input) {
      kyc {
        id
        complianceType
      }
      missingParameters
    }
  }
`

const KycContext = createContext(null)
export { KycContext }

// Layout react component of the dashboard page using tailwindcss
export default function Layout() {
  const params = useParams()

  const { loading, error, data } = useQuery(GET_KYC, {
    variables: { id: params.id },
  })

  const [kyc, setKyc] = useState(null)
  const [updateKycMutation] = useMutation(UPDATE_KYC)

  const updateKyc = async (id, personalInformation = {}, providerInformation = {}) => {
    const { data } = await updateKycMutation({
      variables: {
        input: {
          id,
          providerInformation,
          personalInformation,
        },
      },
    })

    return data
  }

  useEffect(() => {
    if (data) {
      setKyc(data.getKyc)
      if (data.getKyc && data.getKyc.completed) {
        const redirectTo = data.getKyc.rejected ? data.getKyc.errorUrl : data.getKyc.returnUrl
        window.location.href = redirectTo
      }
    }
  }, [data])

  if (loading) {
    return <div>Loading...</div>
  }
  if (error) {
    return <div>Error...</div>
  }

  return (
    <KycContext.Provider value={{ kyc, setKyc, updateKyc }}>
      <Helmet>
        <title>Orionx - KYC</title>
        <script src="https://prod-web-plugins.s3.amazonaws.com/liveness/js/liveness.js"></script>
        <script src="https://prod-web-plugins.s3.amazonaws.com/autocapture/autocapture.js"></script>
        {/* <script src="https://sandbox-web-plugins.s3.amazonaws.com/liveness/js/liveness.js"></script>
        <script src="https://sandbox-web-plugins.s3.amazonaws.com/autocapture/autocapture.js"></script> */}
      </Helmet>
      <div className={styles.container}>
        <NavBar />
        <div className="flex justify-center items-center max-w-full my-10 mx-auto">
          <Outlet />
        </div>
      </div>
    </KycContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}

const styles = {
  container: `
    absolute
    overflow-x-hidden
    w-full
    h-full
    top-0
    left-0
    bg-white
    dark:bg-ox-gray-950
  `,
}
